import { Check } from "lucide-react";
import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { ROADMAP } from "@/content/pages";

export default function RoadmapPage() {
  return (
    <PageShell testid="roadmap-root" seo={{
      title: "Roadmap — Sema",
      description: "What Sema is shipping now, what's next, and what's coming later. A transparent look at where the semantic layer is headed.",
      keywords: "sema roadmap, product roadmap, upcoming features",
      path: "/roadmap",
    }}>
      <PageHero testid="roadmap-h1" eyebrow="Roadmap"
        title="Where Sema is headed."
        subtitle="We build in the open. Here's what's live, what we're working on next, and what's further out." />

      <section className="pb-24">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-6 px-6 lg:grid-cols-3">
          {ROADMAP.columns.map((col) => (
            <div key={col.tag} data-testid={`roadmap-col-${col.tag.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="rounded-2xl border border-border/60 bg-card/50 p-7 backdrop-blur">
              <span className="inline-flex items-center gap-2 rounded-full px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em]"
                style={{ backgroundColor: `${col.accent}1f`, color: col.accent }}>
                <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: col.accent }} />{col.tag}
              </span>
              <ul className="mt-6 space-y-3.5">
                {col.items.map((it) => (
                  <li key={it} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground/90">
                    <Check className="mt-0.5 h-4 w-4 flex-shrink-0" style={{ color: col.accent }} strokeWidth={2.4} />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
